import { LicenseInfo } from '@mui/x-license';

const licenseKey =
  '5daf2a8984d428dc031b145ba33e596bTz0xMDQ2MjIsRT0xNzY2MjMzMDk2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

LicenseInfo.setLicenseKey(licenseKey);

export default function MuiXLicense() {
  return null;
}
